<template>
    <div id="categories-show" class="row-v2">
        <div class="col">
            <!-- <template v-if="movies.data">
                <movie-item-vertical-component :movie="movie" v-for="movie in movies"/>
            </template>
            <loading-component v-else /> -->
        </div>
    </div>
</template>
<script>
    'use strict';
    export default {
        name: 'show',
        data() {
            return {
                movies: {},
                category: null,
            }
        },
        created() {
            this.load();
        },
        watch: {
            $route() {
                this.load()
            }
        },
        methods: {
            load: function() {
                let slug = this.$route.params.slug;
                window.api.categories.show(slug, {}, () => {});
            }
        }
    }
</script>
<style lang="css" scoped>
</style>